// BatteryCache.js
//
// Battery catalogue per rk (name, vendor, capacity, levels, plugIn/plugOut, ems).
// Live state lives in BatStateCache. get()/getAll()/addOrUpdate() come from CacheBase2.
import CacheBase2 from '../../../services/engines/CacheBase2';

const _name = 'BatteryCache';

class BatteryCache extends CacheBase2 {
    _name = _name;
}

const batteryCache = new BatteryCache();
export default batteryCache;
